import { render, staticRenderFns } from "./FazerDiagnostico.vue?vue&type=template&id=e4841904&scoped=true"
import script from "./FazerDiagnostico.vue?vue&type=script&lang=js"
export * from "./FazerDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./FazerDiagnostico.vue?vue&type=style&index=0&id=e4841904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4841904",
  null
  
)

export default component.exports